import React, {useEffect, useState, useRef, useContext} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@state/actions';
import selectors from '@state/selectors';
import {IFormatPlatform, IProps} from './types';
import * as S from './styles';
import { default as D } from '@assets/themes/dimensions';
import { FilterIcon } from '@assets/icons/filterIcon';
import FilterCheck from '@components/Filter';
import Search from '../Search';
import { TemplatesContext } from '@utils/DOIgnition/TemplatesContext';
import {IDSConfig, IBrandDefinition,IPlatform, IFormat} from '@state/dsconfig/types';
import { otherElementHasColor } from '@utils/colors';
import { UserAccessContext } from '@utils/DOIgnition/UserAccessContex';
import { CommonFontsContainer } from '@routes/private/Editor/Editor/Pickers/FontFamilyPicker/styles';
import { getBrandIdByOEMName } from '@utils/editor';

const Filter:React.FC<IProps> = (props) => {
  const{  filtering, hasDesigns, searching} = useContext(UserAccessContext);
  const [showMenu, setShowMenu]= useState(false)
  const [plataforms, setPlataform]= useState([] as any)
  const [plataformsObj, setPlataformsObj]= useState<IPlatform[]>([])
  const [formats, setFormats]= useState<IFormatPlatform[]>([])
  const [oemFilters, setOemFilters]= useState<string[]>([])
  const [status, setStatus]= useState(["Unpublished", "Published", "Disabled"])
  const dispatch = useDispatch();
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const componentRef = useRef(null);
  const componentRefMenu = useRef(null);

  const handleClick = (e: any)=> {
    if(componentRef && componentRef.current){
        const ref: any = componentRef.current
        if (!ref.contains(e.target) && e.target.id !== 'filterButton' && e.target.id!=='filterIcon'){
          setShowMenu(false);
        }
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [])

  useEffect(() => {
    if(dsConfig){
      let plataforms: any=[]
      let plataformsObj:IPlatform[] = []
      dsConfig.designTypes.forEach((item:any)=>{
          item.platforms.forEach((plataform:any)=>{
            plataforms.push(plataform.name)
            plataformsObj.push(plataform);
          })
      })
      setPlataformsObj(plataformsObj);
      setPlataform(plataforms)      
    }
    

  }, [dsConfig])

  useEffect(()=>{

    refreshFormats();
    refreshOemFilters();

  },[props.filters])


  const refreshOemFilters=()=>{

    let newOemFilters: string[] = []
    Object.keys(props.filters).forEach((key) => {          
      if (props.filters[key].length>0){            
        let item=props.filters[key];
        if (key =='oem')
        {
          item.forEach((text:string, idx:number) => {
            if (text=='Access to all')
              newOemFilters.push(text)            
            else
              newOemFilters.push(getBrandIdByOEMName(text, dsConfig))            
          });
        }

      }
    });    
    setOemFilters(newOemFilters);
  }

  const refreshFormats = ()=>{
    let newformats:IFormatPlatform[] = formats;
    plataformsObj.map((item:IPlatform,index:number)=>{      
      if (!props.filters["platform"].includes(item.name))
      {
          newformats = newformats.filter(f=>f.platform!= item.name);
      }            
    })
    setFormats(newformats)            
  }

  const handleClickBtnFilter = ()=>setShowMenu(!showMenu);
  const handleChangeFilters = (value:any, type:string, add:boolean)=>{
    if (type=="platform")
    {
      let newformats:IFormatPlatform[] = [];
        plataformsObj.map((item:IPlatform,index:number)=>{
          if (item.name === value)
          {
            if (add)
            {
              newformats= formats;
              item.formats.map((format:IFormat, index:number)=>{
                let formatPlatform :IFormatPlatform ={
                  platform: item.name,
                  name: format.name,
                  width: format.width,
                  height: format.height
                }
                newformats.push(formatPlatform);
              })
            }              
            else
            {
              newformats = formats.filter(f=>f.platform!= item.name);
            }

          }
        })            
      setFormats(newformats)


      
    }
    props.onChange(value, type, add)
  };
  

  return (
    <>
      <S.Root>
        <Search openMenu={props.openMenu} onSearchClick={props.onSearchClick} deteleItem={props.deteleItem} oemFilters={oemFilters}/>

        <S.FilterContainer>
            <S.ButtonFilter onClick={handleClickBtnFilter} id="filterButton">
                <FilterIcon style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: "5px", marginRight: "14px"}}/>
                Filter
            </S.ButtonFilter>
        </S.FilterContainer>
      </S.Root >
      {dsConfig&&
        <S.MenuFilter ref={componentRef} style={{
          display: showMenu?'block':'none'
          }}>
          <S.Container >
            <S.List >
              <S.Label>Brand Access</S.Label>
              <FilterCheck 
                    key={`oemall`}
                    label={`Access to all`} 
                    type="oem" 
                    onChange={handleChangeFilters}
                    checked={props.filters['oem'].includes(`Access to all`)}/>
              { dsConfig.brands.sort((a, b) => {
                  var textA = a.name.toUpperCase();
                  var textB = b.name.toUpperCase();
                  return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                }).map((text:IBrandDefinition, index:number) => 
                    <FilterCheck 
                    key={`oem${index}`}
                    label={text.name} 
                    type="oem" 
                    onChange={handleChangeFilters}
                    checked={props.filters['oem'].includes(text.name)}/>
              )}
            </S.List>           
          </S.Container>
        </S.MenuFilter>
      }
    </>
  );
}

export default Filter;